package one.healthium.insights.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.util.fastForEach
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.ui.components.items.Carousel
import one.healthium.insights.ui.components.items.ContentAnchor
import one.healthium.insights.ui.components.items.ContentButton
import one.healthium.insights.ui.components.items.ContentColumn
import one.healthium.insights.ui.components.items.ContentDay
import one.healthium.insights.ui.components.items.ContentDecorator
import one.healthium.insights.ui.components.items.ContentHorizontalList
import one.healthium.insights.ui.components.items.ContentImage
import one.healthium.insights.ui.components.items.ContentLine
import one.healthium.insights.ui.components.items.ContentPlainText
import one.healthium.insights.ui.components.items.ContentRichText
import one.healthium.insights.ui.components.items.ContentRow
import one.healthium.insights.ui.components.items.ContentSpace
import one.healthium.insights.ui.components.items.ContentText
import one.healthium.insights.ui.components.items.ContentTitle
import one.healthium.insights.ui.components.items.Header
import one.healthium.insights.ui.components.items.ImageCard
import one.healthium.insights.ui.components.items.ListItem
import one.healthium.insights.ui.components.items.ListItemPreview
import one.healthium.insights.ui.components.items.Tips

@Composable
fun ContentEntryItem(
    modifier: Modifier = Modifier,
    entry: ContentEntry,
    anchorState: AnchorState,
    onActionClicked: (ActionModel) -> Unit,
    actionButton: String? = null,
    onTextActionClicked: () -> Unit = {},
    isMetrics: Boolean,
) {
    when (entry) {
        is ContentEntry.TitleEntry -> ContentTitle(modifier, entry, actionButton, onTextActionClicked)
        is ContentEntry.ImageEntry -> ContentImage(modifier, entry)
        is ContentEntry.TextEntry -> ContentText(modifier, entry)
        is ContentEntry.RichTextEntry -> ContentRichText(modifier, entry)
        is ContentEntry.DayEntry -> ContentDay(modifier, entry, onActionClicked)
        is ContentEntry.CardEntry -> ContentCard(modifier, entry, onActionClicked)
        is ContentEntry.Carousel -> Carousel(modifier, entry.content, entry.variant, onActionClicked)
        is ContentEntry.HeaderEntry -> Header(modifier, entry.text)
        is ContentEntry.ImageCard -> ImageCard(modifier, entry, onActionClicked)
        is ContentEntry.ListItem -> ListItem(modifier, entry, onActionClicked)
        is ContentEntry.ListItemPreview -> ListItemPreview(modifier, entry, onActionClicked)
        is ContentEntry.Tips -> Tips(modifier, entry)
        is ContentEntry.GroupEntry -> Unit /* handled in ContentRenderer */
        is ContentEntry.ShoppingList -> Unit /* handled in ContentRenderer */
        is ContentEntry.StickyContent -> Unit /* handled in ContentRenderer */
        is ContentEntry.Button -> ContentButton(modifier, entry, onActionClicked)
        is ContentEntry.Line -> ContentLine(modifier, entry)
        is ContentEntry.PlainText -> ContentPlainText(modifier, entry)
        is ContentEntry.Row -> ContentRow(modifier, entry, anchorState, onActionClicked, actionButton, onTextActionClicked, isMetrics)
        is ContentEntry.Column -> ContentColumn(
            modifier = modifier,
            entry = entry,
            anchorState = anchorState,
            onActionClicked = onActionClicked,
            actionButton = actionButton,
            onTextActionClicked = onTextActionClicked,
            isMetrics = isMetrics
        )

        is ContentEntry.Space -> ContentSpace(modifier, entry)
        is ContentEntry.Anchor -> ContentAnchor(
            modifier = modifier,
            entry = entry,
            anchorState = anchorState,
            onActionClicked = onActionClicked,
            isMetrics = isMetrics,
            actionButton = actionButton,
            onTextActionClicked = onTextActionClicked
        )

        is ContentEntry.Decorator -> ContentDecorator(
            modifier = modifier,
            entry = entry,
            anchorState = anchorState,
            onActionClicked = onActionClicked,
            isMetrics = isMetrics,
            actionButton = actionButton,
            onTextActionClicked = onTextActionClicked
        )

        is ContentEntry.HorizontalList -> ContentHorizontalList(
            modifier = modifier,
            entry = entry,
            anchorState = anchorState,
            onActionClicked = onActionClicked,
            isMetrics = isMetrics,
            actionButton = actionButton,
            onTextActionClicked = onTextActionClicked
        )

        is ContentEntry.UnitSelectorContainer -> {
            if (isMetrics) {
                entry.metric.fastForEach { childEntry ->
                    ContentEntryItem(
                        modifier = modifier,
                        entry = childEntry,
                        anchorState = anchorState,
                        onActionClicked = onActionClicked,
                        actionButton = actionButton,
                        onTextActionClicked = onTextActionClicked,
                        isMetrics = isMetrics,
                    )
                }
            } else {
                entry.imperial.fastForEach { childEntry ->
                    ContentEntryItem(
                        modifier = modifier,
                        entry = childEntry,
                        anchorState = anchorState,
                        onActionClicked = onActionClicked,
                        actionButton = actionButton,
                        onTextActionClicked = onTextActionClicked,
                        isMetrics = isMetrics,
                    )
                }
            }
        }
    }
}